import React, { useEffect, useState } from 'react';
import MessageCard from '../../../../components/card/message-card';
import { getDateTimeFormatString } from '../../../../components/common/common-helper';
import MicroLoader from '../../../../components/UI/loader/micro-loader';
import { RentalExtensionRequest } from '../../../../services/entities/requests/rental-extension-request';
import { doExtendRentalFunctionality } from '../../../../shared/api/common-api';
import { RequestHandleType } from '../../../../shared/utility/enum-utility';
import { convertFoxApiDateToStr } from '../../fox-reservation/fox-res-helper';
import AdditionalChargeDetails from './additional-charge-details';
import RentalInformation from './rental-information';

function ExtendChargeFinish(props) {
    const { rentalExtension, closeModal } = props;
    const [loader, setLoader] = useState(false);
    const [extensionDetails, setExtensionDetails] = useState(null);
    useEffect(() => {
        getExtensionDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getExtensionDetails = async () => {
        const request = new RentalExtensionRequest({
            rentalExtension: { rentalAgreementNum: rentalExtension?.rentalAgreementNum },
            details: true
        });
        setLoader(true);
        const response = await doExtendRentalFunctionality(request, RequestHandleType.RESPONSE_ONLY);
        setExtensionDetails(response);
        setLoader(false);
    }

    return (
        <div className='extend-rental-div'>
            <MessageCard
                contClasses="msg-success-block"
                title="Rental Successfully Extended"
                message={`Your rental (${rentalExtension?.rentalAgreementNum})  has been successfully extended to (${convertFoxApiDateToStr(rentalExtension?.returnDate, getDateTimeFormatString(true, false, true))})`}
                iconClass="fas fa-check-circle"
            />
            <div className='flex-row gap-2 mt-3'>
                <div className='flex-column row-gap-1' style={{ width: "50%" }}>
                    <RentalInformation rentalData={rentalExtension} step={3} />
                </div>
                <div className='flex-column extend-pricing row-gap-1' style={{ width: "50%", height: "500px", overflowX: "auto" }}>
                    {loader ? <MicroLoader /> : ""}
                    {extensionDetails?.rentalExtensions?.map((data) => {
                        return <AdditionalChargeDetails key={data?.returnDate} showLoader={loader} rentalExtension={data} isExpand={extensionDetails?.rentalExtensions.length === 1 && true} />
                    })
                    }
                </div>
            </div >
            <hr />
            <div className='btn-container m-0'>
                <button className='btn btn-primary' onClick={() => closeModal()}>Ok</button>
            </div>
        </div >
    )
}

export default ExtendChargeFinish